import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { chatController } from '@/stores/chatController'
import { useUiStore } from '@/stores/uiStore'

/** "New chat": go to /, forget the previous new-chat turn, focus the composer. */
export function useNewChat() {
  const navigate = useNavigate()
  return useCallback(() => {
    chatController.resetNewChat()
    const ui = useUiStore.getState()
    ui.closeSources()
    ui.setMobileSidebarOpen(false)
    navigate('/')
    ui.focusComposer()
  }, [navigate])
}
